<template>
  <ul class="tdx-scroll-navigation flx">
    <li
      v-for="(item, ind) in items"
      :key="ind"
      class="tdx-scroll-navigation__item bor--all bor--radius-30 pt-6 pt-10--l pb-6 pb-10--l pl-20 pr-20 txt--pointer"
      :class="{
        'tdx-scroll-navigation__item--active bg--color-10 bor--transp':
          item[valueField] === currentValue,
        'bor--transp-02': item[valueField] !== currentValue,
      }"
      @click="handleItemClick(ind, item)"
    >
      <span
        :class="{
          'tdx-scroll-navigation__text--active inline-block txt--color-04':
            item[valueField] === currentValue,
          'txt--color-03': item[valueField] !== currentValue,
        }"
        class="tdx-scroll-navigation__text txt--bold txt--14px txt--16px--l txt--height-18px txt--height-20px--l"
      >
        <slot name="text" v-bind="item" />
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'TdxScrollNavigation',
  props: {
    items: { type: Array, default: () => [] },
    valueField: { type: String, default: '' },
    currentValue: { type: [Number, String], default: '' },
  },
  methods: {
    handleItemClick (index, item) {
      this.$emit('item-clicked', { index, item })

      if (this.valueField) {
        this.$emit('input', item[this.valueField])
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tdx-scroll-navigation {
  gap: toRem(12px);
  flex-direction: row;
  overflow: auto;
  padding-bottom: toRem(4px);
  padding-left: 0 !important;

  @include bp(l) {
    flex-direction: column;
    overflow: initial;
    padding-bottom: 0;
  }

  &__item {
    display: block;

    @include bp(0, l) {
      white-space: nowrap;
    }
  }

  &__text {
    transition-duration: 0.25s;
    opacity: 0.7;

    &:hover,
    &--active {
      opacity: 1;
    }
  }
}
</style>
